import { InventoryCountItemTemplateItemImportPage } from "@/features/inventory-count-template-item/pages/InventoryCountItemTemplateItemImportPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/admin/inventory-count-template-item/$id/import",
)({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["inventory_count_item_template.edit"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return (
		<InventoryCountItemTemplateItemImportPage
			inventoryCountItemTemplateID={id}
		/>
	);
}
